export default __webpack_public_path__ + "static/867-b8c0f16c7da8859d8d0af75349887c86.gif";